export default "__VITE_ASSET__CokALRsR__"